import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=071da5f4&"
import script from "./Entity.vue?vue&type=script&lang=ts&"
export * from "./Entity.vue?vue&type=script&lang=ts&"
import style0 from "./Entity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports